export default function initMobileFootDropdowns() {
	const footDropdowns = document.querySelectorAll('.foot-nav:not([data-imfd])');
	if (!footDropdowns.length) return;

	[...footDropdowns].forEach((footDropdown) => {
		footDropdown.dataset.imfd = 'true';
		const footDropdownTitle = footDropdown.querySelector('.foot-nav__title');
		const footDropdownList = footDropdown.querySelector('.foot-nav__list');
		if (!footDropdownTitle || !footDropdownList) return;
        footDropdownTitle.addEventListener('click', () => {
			footDropdownTitle.classList.toggle('_open');
			footDropdownList.classList.toggle('_open');
            footDropdown.classList.toggle('_open');
		})
	});
}
